export const RESTRICTIONS_STATUS = {
  active: 0,
  inactive: 1,
};

export const RESTRICTION_FEATURE_NAMES = {
  empty: "",
  order_type: "order_type",
};
